import { defineStore } from 'pinia';
import { BrowsingHistory } from '@/interfaces';

const historyStore = defineStore('history', {
  state: () => ({ values: null as BrowsingHistory[] | null }),
});

export default historyStore;
